import axios from 'axios';

const rawBaseUrl = String(import.meta.env.VITE_API_URL ?? '/api/v1').trim();
const normalizedBaseUrl = /^https?:\/\//i.test(rawBaseUrl)
  ? rawBaseUrl.replace(/\/+$/, '')
  : `/${rawBaseUrl.replace(/^\/+/, '').replace(/\/+$/, '')}`;

export const apiClient = axios.create({
  baseURL: normalizedBaseUrl,
  timeout: 15000,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Ensure CSRF cookie is present before the first mutating request
let csrfReady = false;

async function ensureCsrf() {
  if (!csrfReady) {
    await axios.get('/sanctum/csrf-cookie', { withCredentials: true });
    csrfReady = true;
  }
}

apiClient.interceptors.request.use(async (config) => {
  if (config.method && !['get', 'head', 'options'].includes(config.method)) {
    await ensureCsrf();
  }
  return config;
});

// CSRF cookie refresh for Sanctum SPA auth
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 419) {
      // CSRF token expired — refresh and retry
      csrfReady = false;
      await axios.get('/sanctum/csrf-cookie', { withCredentials: true });
      csrfReady = true;
      return apiClient.request(error.config);
    }
    return Promise.reject(error);
  },
);
